import { apiClient } from '@/utils/axios.ts'

const getSentScriptIdsByFanId = async (
  creatorId: number,
  fanId: number,
): Promise<number[]> => {
  const response = await apiClient.get(
    `/settings/scripts/creators/${creatorId}/fans/${fanId}`,
  )

  return response.data
}

export const scriptsService = {
  getSentScriptIdsByFanId,
}
